import React, { FC } from 'react';
import translate from '@translate';
import { useNavigate } from 'react-router-dom';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { AddIcon, ReloadIcon } from 'src/components/SkladonIcon/Icons';
import TopBlockAdmin from '../AdminContainer/TopBlock';
import { ExportTypeType } from 'src/types/table';
import ExportTableAction from 'src/components/ExportTableAction';

interface TopBlockProps {
  reloadCarriersList: () => void;
  permissionCreate: boolean;
  handleExport: (type: ExportTypeType) => void;
}

const TopBlock: FC<TopBlockProps> = (props) => {
  const navigate = useNavigate();

  const handleNew = () => {
    navigate(`/admin/carriers/new`);
  };

  return (
    <>
      <TopBlockAdmin />
      <BodyTopBlock
        actions={[
          {
            node: (
              <ExportTableAction title={translate('carriers.action.exportFile')} handleExport={props.handleExport} />
            ),
          },
          {
            onClick: props.reloadCarriersList,
            icon: <ReloadIcon />,
            tooltip: translate('carriers.action.synchronizeTable'),
            variant: 'outlined',
          },
          {
            label: translate('carriers.action.createNew'),
            onClick: handleNew,
            icon: <AddIcon />,
            hidden: !props.permissionCreate,
          },
        ]}
      />
    </>
  );
};

export default TopBlock;

